export const LOGIN = `${process.env.REACT_APP_POOL_HOST}/login`;
export const OTP = `${process.env.REACT_APP_POOL_HOST}/otp`;
export const LOGOUT = `https://${process.env.REACT_APP_AUTH_DOMAIN_ADDRESS}/v2/logout?client_id=${process.env.REACT_APP_AUTH_CLIENT_ID}&returnTo=${process.env.REACT_APP_BOND_HOST}`;
export const LOGOUT_ALL_DEVICES = '/logout-all-devices';
export const CHANGE_PASSWORD = `${process.env.REACT_APP_POOL_HOST}/change-password`;
export const FORGOT_PASSWORD = `${process.env.REACT_APP_POOL_HOST}/forgot-password`;
export const SET_PASSWORD = `${process.env.REACT_APP_POOL_HOST}/set-password`;
export const HOME = '/home';
export const FIREWALL = '/firewall';

export const CLIENT_SIGNUP = `${process.env.REACT_APP_CS_HOST}/sign-up`;
export const CLIENT_DOCUMENT = `${process.env.REACT_APP_CS_HOST}/client/:entityId/client-snapshot`;
export const CLIENT_INFO_REPORT = `${process.env.REACT_APP_CS_HOST}/client/:entityId/client-snapshot`;
export const CLIENT_SNAPSHOT = `${process.env.REACT_APP_CS_HOST}/client/:entityId/client-snapshot`;
export const CLIENT_GLOBAL_HOME = `${process.env.REACT_APP_CS_HOST}/client/:entityId/home`;
export const CLIENT_INFO_REPORT_V1 = `${process.env.REACT_APP_CS_HOST}/client/:entityId/info-report`;
export const CLIENT_INSIGHTS = `${process.env.REACT_APP_CS_HOST}/insight`;
export const CLIENT_LEADS = `${process.env.REACT_APP_CS_HOST}/leads`;
export const RETAIL_LEADS = `${process.env.REACT_APP_CS_HOST}/retail-leads`;
export const CLIENT_TASKS = `${process.env.REACT_APP_CS_HOST}/tasks`;
export const CLIENT_PEOPLE = `${process.env.REACT_APP_CS_HOST}/people`;
export const CLIENT_COMPANIES = `${process.env.REACT_APP_CS_HOST}/companies`;
export const CLIENT_AUDITORS = `${process.env.REACT_APP_CS_HOST}/auditors`;
export const CLIENT_PENDING_DOCUMENTS = `${process.env.REACT_APP_CS_HOST}/client/:entityId/document/pending`;
export const CLIENT_FINANCIAL_RATIOS = `${process.env.REACT_APP_CS_HOST}/client/:clientId/info-report/financials/financial_ratios`;
export const CLIENT_COMPANY_SNAPSHOT = `${process.env.REACT_APP_CS_HOST}/client/:clientId/info-report/company_snapshot/company_snapshot`;
export const CAG_SETTINGS = `${process.env.REACT_APP_CS_HOST}/settings`;
export const EXPRESS_INTEREST = `${process.env.REACT_APP_CS_HOST}/express-interest`;
export const CLIENT_EXPRESS_INTEREST = `${process.env.REACT_APP_CS_HOST}/client/:entityId/express-interest`;
export const CLIENT_EXPRESS_INTEREST_PRODUCT = `${process.env.REACT_APP_CS_HOST}/express-interest`;
export const LIQUIDITY_ANALYSIS = `${process.env.REACT_APP_CS_HOST}/liquidity-analysis`;
export const FEEDBACK = `${process.env.REACT_APP_CS_HOST}/feedback`;
export const PEER_COMPARISON = `${process.env.REACT_APP_CS_HOST}/peer-comparison`;
export const INVESTOR_EXPLORE = `${process.env.REACT_APP_CS_HOST}/explore`;
export const INVESTOR_DEFAULT_HOME = `${process.env.REACT_APP_CS_HOST}/home`;

export const CLIENT_DEFAULT_HOME = '/client';
export const CAG_DEFAULT_HOME = `${process.env.REACT_APP_CS_HOST}/leads`;
export const ACTOR_DEFAULT_HOME = '/:type/transactions';
export const ANCHOR_DEFAULT_HOME = `${process.env.REACT_APP_SCF_HOST}/`;
export const CREDIT_DEFAULT_HOME = `${process.env.REACT_APP_CS_HOST}/`;
export const CONNECTOR_DEFAULT_HOME = `${process.env.REACT_APP_CS_HOST}/connector`;

export const DOCUMENT_COLLABORATOR_CP = '/cp/:transId/documents/:docId/editor';
export const DOCUMENT_COLLABORATOR_NCD = '/ncd/:transId/documents/:docId/editor';
export const DOCUMENT_COLLABORATOR = '/:type/:transId/documents/:docId/editor';

export const ONBOARDED_CLIENTS = `${process.env.REACT_APP_CS_HOST}/clients`;
export const INVESTOR_SETTINGS = `${process.env.REACT_APP_CS_HOST}/settings`;

export const ENTITY_LIST = `${process.env.REACT_APP_CS_HOST}/entities`;
export const ENTITY = `${process.env.REACT_APP_POOL_HOST}/entities/:entityId`;
export const ENTITY_ADD = `${process.env.REACT_APP_POOL_HOST}/entities/add`;
export const ENTITY_USER_ADD = `${process.env.REACT_APP_POOL_HOST}/entities/:entityId/user`;
export const USER_ADD = `${process.env.REACT_APP_POOL_HOST}/user`;
export const SURVEY = '/surveys/:surveyId';
export const SURVEY_SUCCESS = '/survey-success';
export const TRANSACTION_DETAIL = '/:product/:transId';
export const DEMAND_COLLECTION = '/demand-collection';
export const MANAGE_ROLES = '/manage-roles';
export const MANAGE_NOTIFICATIONS = '/manage-notifications';
export const INTERNAL_MANAGE_ROLE = `${process.env.REACT_APP_POOL_HOST}/entities/:entityId/:actor/manage-roles`;

export const INITIATE = '/initiate/transaction';

// Routes Transistion
export const SERVICER_REPORT_OLD = '/:cp/securitization/:transId/servicer-report';
export const REPORTS_OLD = '/:cp/reports';
export const REPORTS = '/reports';
export const TRANSACTION_DETAIL_OLD = '/:cp/:product(securitization|ptc|ncd|cp|ps|tl|da)/:transId';
export const RESOURCES = `${process.env.REACT_APP_POOL_HOST}/resources`;

export const INVESTOR_SIGNUP = '/investor_signup';
export const MORATORIUM = '/moratorium/detail/:entityId';
export const MORATORIUM_REQUESTS = '/moratorium/requests';

// Common Dashboard
export const DASHBOARD_HOME = '/dashboard';
export const DASHBOARD_HOME_POOL = `${process.env.REACT_APP_POOL_HOST}/dashboard`;

export const DASHBOARD_POOL_PORTFOLIO = '/dashboard/pool-purchase-portfolio/:type';
export const NEW_DASHBOARD = '/new-dashboard';
export const NEW_DASHBOARD_POOL_PORTFOLIO = '/dashboard/pool-purchase-portfolio/all';
export const DASHBOARD_PORTFOLIO = '/dashboard/portfolio';
export const DASHBOARD_PORTFOLIO_PRODUCTS = '/dashboard/portfolio/products';
export const DASHBOARD_PORTFOLIO_CLIENT = '/dashboard/portfolio/client';
export const DASHBOARD_PORTFOLIO_SECTOR = '/dashboard/portfolio/sector';
export const DASHBOARD_PORTFOLIO_TRANSACTION = '/dashboard/portfolio/transaction';

export const VENDOR_ONBOARDING = `${process.env.REACT_APP_SCF_HOST}/onboarding/vendor`;

export const TOOLS = '/tools';
export const REGULATORY_REPORTS = '/regulatory-reports';
export const TOOLS_MCLR = '/tools/mclr';

export const NOTIFICATIONS = '/notifications';
export const ORDER_MANAGEMENT = `${process.env.REACT_APP_CS_HOST}/order-management`;
export const CAM_BUILDER = `${process.env.REACT_APP_CS_HOST}/cam-builder`;
export const QUICKACCESS_RESOURCES = '/quick-access/resources';
export const QUICKACCESS_SECTORNOTES = '/quick-access/sector-notes';

export const TRANS_LIST_TYPE = '/:type/transactions';

// Other platforms
export const COLENDING_EXPLORE = `${process.env.REACT_APP_COLEND_HOST}/explore/all`;
export const PLUTUS_EXPLORE = `${process.env.REACT_APP_PLUTUS_HOST}/explore`;
export const SCF_EXPLORE = `${process.env.REACT_APP_SCF_HOST}/explore-programs/all`;

export const GENERIC_DEAL_DETAILS_VIEW = '/:productType(bg|od|stl|cc|lc|epc|pcfc|factoring|ra|discounting|ps)/:transId';
export const PUBLIC_ROUTES = [INVESTOR_SIGNUP, SET_PASSWORD, FORGOT_PASSWORD, SURVEY, SURVEY_SUCCESS];
